<template>
  <div id="auditreview" >
    <div class="header">
    <el-row type="flex" justify="center" align="middle" :gutter="20" style="height:100%;">
      <el-col :xs="24" :sm="16" :md="16" :lg="10" class="header-tips">
      <!-- <span class="header-tips"> -->
        <audio class="header-tips-audio" :src="newContent.mediaurl" controls="controls" controlsList="nodownload" oncontextmenu="return false" v-if="newContent.mediaurl">
        您的浏览器不支持 audio 标签。
        </audio>
      <!-- </span> -->
      </el-col>

      <el-col :xs="24" :sm="6" :md="6" :lg="4">
      <span class="header-btn">
        <el-button type="danger" @click="handleAuditFormEdit(newContent)" :disabled="newContent.done">驳回</el-button>
        <el-button type="success" @click="releaseNews(newContent.id)" :disabled="newContent.done">通过</el-button>
      </span>
      </el-col>
    </el-row>
    </div>
      <el-row type="flex" justify="center" :gutter="20">
        <el-col :xs="24" :sm="24" :md="22" :lg="14">
          <div class="editor-content">
            <!-- <el-col :span="24" class="el-item"> -->
            <div class="news-box">
                <div class="box-header">
                    <span class="new-type fs-label">{{formatCategory}}</span>
                    <span class="hot-level fs-label">{{formatHotIndex}}</span>
                </div>
                <div class="box-title">
                    <h1 class="fs-title">{{newContent.title}}</h1>
                </div>
                <div class="box-author fs-label" >
                  <span>{{newContent.date}}&nbsp;</span>
                  <span v-if="newContent.editorname">&nbsp;编:{{newContent.editorname}}</span>
                  <span v-if="newContent.hostname">&nbsp;播:{{newContent.hostname}}</span>
                  <span v-else-if="newContent.host">&nbsp;播:{{newContent.host}}</span>
                  <span v-if="newContent.verifiername">&nbsp;审:{{newContent.verifiername}}</span>
                </div>
                <div class="box-content">
                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="20" :sm="20" :md="12" :lg="10">
                    <img class="box-image" :src="newContent.cover" v-show="newContent.cover"/>
                    </el-col>
                  </el-row>

                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <p class="box-text fs-text">{{newContent.content}}</p>
                    </el-col>
                  </el-row>
                </div>

                <div class="box-source fs-text" >
                  <span>新闻来源:</span>
                  <span>{{formatSourcefrom}}</span>
                </div>
                <div class="box-origin fs-text" >
                  <span>原文地址:</span><a :href="newContent.sourceurl" target="_blank">
                  <span class="link-url">{{newContent.sourceurl}}</span></a>
                </div>

                <div class="box-foot fs-label" >
                  <!-- <div v-for="(lable, index) in formatLabels" :key="index">
                    <span v-if="index === 0">{{lable}}</span>
                    <span v-else>&nbsp;/ {{lable}}</span>
                  </div> -->
                  <span>{{formatLabels2}}</span>
                </div>

                <!-- <div class="pre-next-page">
                  <span ><router-link :to="{ path: urladdr, query: {id:newsdata[preNewsId].id, index:preNewsId} }" v-if="preNewsId !== -1"><p class="page-text fs-label">上一篇 {{newsdata[preNewsId].title}}</p></router-link></span>
                  <span ><router-link :to="{ path: urladdr, query: {id:newsdata[nextNewsId].id, index:nextNewsId} }" v-if="nextNewsId !== -1"><p class="page-text fs-label">下一篇 {{newsdata[nextNewsId].title}}</p></router-link></span>
                </div> -->

                <el-row :gutter="20" class="pre-next-page" type="flex" justify="space-between">
                  <el-col :xs="7" :sm="24" :md="12" :lg="12">
                    <div>
                      <router-link :to="{ path: urladdr, query: {id:newsdata[preNewsId].id, index:preNewsId} }" v-if="preNewsId !== -1"><p class="page-text fs-label"> <el-button type="primary" plain>上一篇</el-button></p></router-link>
                    </div>
                  </el-col>

                  <el-col :xs="7" :sm="24" :md="12" :lg="12">
                    <div>
                      <router-link :to="{ path: urladdr, query: {id:newsdata[nextNewsId].id, index:nextNewsId} }" v-if="nextNewsId !== -1"><p class="page-text fs-label"> <el-button type="primary" plain>下一篇</el-button></p></router-link>
                    </div>
                  </el-col>
                </el-row>


            </div>

          </div>
        </el-col>
    </el-row>

    <!--驳回界面-->
    <el-dialog :title="auditFormTitle" v-model="auditFormVisible" :close-on-click-modal="false">
      <el-form :model="auditForm" :rules="auditFormRules" ref="auditForm" label-width="80px">

        <el-form-item label="移动至" prop="state" >
          <el-select v-model="auditForm.state" clearable placeholder="请选择" @change="handleCategoryChange">
            <el-option
              v-for="item in formatAuditType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="原因" prop="tip">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 60}"
            placeholder="请输入驳回理由，最少5个字，最多60个字。"
            v-model="auditForm.tip">
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="auditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{auditFormBtn}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Message } from 'element-ui'
    import { newsType, hotsType, newsPlatform, auditType } from '../../config/config'
    import { getNowTime } from '../../utils/com.js'
    // import { markdownEditor } from 'vue-simplemde';
    import '../../static/style/audit/review.scss'

    export default {
        data: function(){
          return {
            //编辑界面数据
            editForm: {
              done: false,
              mediaurl: '',
              loading: false,
            },
            auditFormVisible: false,
            auditFormTitle: '驳回',
            auditFormBtn: '提 交',
            editLoading: false,
            auditForm: {
              id: null,
              state: null,
              tip: null,
            },
            auditFormRules: {
              state: [
                { required: true, message: '请选择驳回至哪一端', trigger: 'change' }
              ],
              tip: [
                { required: true, message: '请选择驳回理由', trigger: 'blur' },
                { min: 5, max: 80, message: '长度在 5 到 80 个字符', trigger: 'blur' }
              ],
            },
            id: null,
            index: null,
            urladdr: './review',
          }
        },
        computed: {
          ...mapGetters({
              // 映射 this.newsdata 为 store.getters.newContent
              newContent: 'newContent',
              newsdata: 'newsdata',
              newstotal: 'newstotal',
          }),
          formatCategory(){
            return newsType[this.newContent.category] || '';
          },
          formatLabels(){
            return this.newContent.labels.split('#') || [];
          },
          formatLabels2(){
            return this.newContent.labels.split('#').join(' / ') || '';
          },
          formatHotIndex(){
            return hotsType[this.newContent.hotindex+''];
          },
          formatSourcefrom(){
            return this.newContent.sourcefrom || '';
            // return newsPlatform[this.newContent.sourcefrom]|| '';
          },
          // showMusicFileList: function () {
          //   // `this` points to the vm instance
          //   if(!this.editForm.mediaurl){
          //     return [];
          //   }
          //   let fo = {};
          //   fo.url = this.editForm.mediaurl;
          //   fo.name = fo.url.split('/')[fo.url.split('/').length-1];
          //   // console.debug("showCycleFileList> fo:%o", fo);
          //   return [fo];
          // },
          formatAuditType(){
            let typelists = [];
            for(let i in auditType){
              let typelist = {}
              typelist.value = i;
              typelist.label = auditType[i];
              typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
          },
          preNewsId(){
            if(this.newsdata.length && this.newsdata.length> 0 && this.index > 0){
              console.debug("preNewsId> index:%o, pre:%o", this.index, this.index-1);
              return this.index-1
            }else{
              console.debug("preNewsId> -1");
              return -1
            }
          },
          nextNewsId(){
            if(this.newsdata.length && this.newsdata.length> 0 && this.index < this.newsdata.length-1){
              console.debug("nextNewsId> index:%o, next:%o", this.index, this.index+1);
              return this.index + 1
            }else{
              console.debug("nextNewsId> -1");
              return -1
            }
          }
        },
        created() {
          // this.id = this.$route.query.id || '';
          // let index = this.$route.query.index || 0;
          // this.index = parseInt(index);
          // console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
          // let item = this.reqNewsContent(this.id, this.newsdata);
          // console.debug("created> item:%o", item);
          // this.updateNewsContent(item);
          this.updateNewsConten();



          console.debug("created> newContent:%o", this.newContent);
          // if(this.newContent.mediaurl){
          //   this.editForm.mediaurl = this.newContent.mediaurl;
          // }
          // console.debug("created> editForm:%o", this.editForm);
          // if(this.newContent.tip){
          //   Message({
          //     showClose: true,
          //     duration: 0,
          //     message: `驳回理由: ${ this.newContent.tip }`,
          //     type: 'warning'
          //   });
          // }
        },
        destroyed(){
          Message.closeAll();
        },
        watch: {
            '$route' (to, from){
                console.debug("watch>route start to:%o, from:%o", to, from);
                console.debug("watch route> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
                // this.id = this.$route.query.id || '';
                // let index = this.$route.query.index || 0;
                // this.index = parseInt(index);
                // let item = this.reqNewsContent(this.id, this.newsdata);
                // console.debug("watch> item:%o", item);
                // this.updateNewsContent(item);
                this.updateNewsConten();
            }
        },
        methods: {
          ...mapActions({
            // 映射 this.editNewsContent() 为 this.$store.dispatch('editNewsContent')
            editNewsContent: 'editNewsContent',
            transferNewsState: 'transferNewsState',
            updateNewsContent: 'updateNewsContent',
            updateNewsDataDone: 'updateNewsDataDone'
          }),
          updateNewsConten() {
            this.id = this.$route.query.id || '';
            let index = this.$route.query.index || 0;
            this.index = parseInt(index);
            // console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
            let item = this.reqNewsContent(this.id, this.newsdata);
            // console.debug("created> item:%o", item);
            this.updateNewsContent(item);

            if(this.newContent.tip){
              Message({
                showClose: true,
                duration: 0,
                message: `驳回理由: ${ this.newContent.tip }`,
                type: 'warning'
              });
            }else{
              Message.closeAll();
            }

          },
          reqNewsContent(id, datalist) {
            console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
            let data = null;
            let hasUser = datalist.some(u => {
              if (u.id === id ) {
                data = JSON.parse(JSON.stringify(u));
                return true;
              }
            });
            console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
            return data;
          },
          releaseNews(id){
            console.debug("releaseNews> id:%o", id);
            var that = this;
            let param = {};
            param.id = id;
            // http://he.banma.jizhuoyangqing.com/wiki/doku.php?id=kx:optimize2
            param.state = 6; //4; 内部接口修改：/news/transfer 审核员 在前端用此接口把新闻审核通过，状态从3变成6.
            param.tip = '';

            this.$confirm('确认通过？', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',              
                center: true
            }).then(() => {
                that.transferNewsState(param).then(
                  (resp) => {
                  console.debug("editNewsContent> resp:%o", resp+0);
                    if(resp.code === 0){
                        that.$message({
                            message: resp.msg,
                            type: 'success'
                        })
                        that.editForm.done = true;
                        let para = {
                          id: param.id,
                          done: true
                        }
                        that.updateNewsDataDone(para);
                        // debugger;
                        that.updateNewsConten();
                        console.debug("transferNewsState>updateNewsDataDone para:%o", para);
                        // this.$router.push({ path: './review',query: { id: this.newContent.id }})
                    }else{
                      that.$message({
                            message: resp.msg,
                            type: 'error'
                        })
                    }
                  }
                );

                
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
           
            

          },
          handleCategoryChange(e){
            console.debug("handleCategoryChange> e:%o", e);
          },
          //显示编辑界面
          handleAuditFormEdit(item) {
            console.debug("handleAuditFormEdit> item:%o", item);
            this.auditFormVisible = true;
            this.auditForm.id = item.id;
            this.auditForm.state = null;
            this.auditForm.tip = '';
          },
          //编辑 or 新增
          editSubmit: function () {
            var that = this;

            that.$refs.auditForm.validate((valid) => {
              if (valid) {
                that.$confirm(`请确认移动至  ${auditType[this.auditForm.state]}  吗？`, '提示', {}).then(() => {
                  that.editLoading = true;
                  that.auditFormBtn = '提交中';
                  console.debug("editSubmit> auditForm:%o", that.auditForm);
                  let param = {};
                  param.id = that.auditForm.id;
                  param.state = that.auditForm.state;
                  param.tip = that.auditForm.tip;
                  that.transferNewsState(param).then(
                    (resp) => {
                    console.debug("editNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          that.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          that.editLoading = false;
                          that.btnEditText = '提 交';
                          that.editForm.done = true;
                          let para = {
                            id: param.id,
                            done: true
                          }
                          that.updateNewsDataDone(para);
                          that.updateNewsConten();
                          console.debug("transferNewsState>updateNewsDataDone para:%o", para);
                          that.auditFormVisible = false;
                      }else{
                        that.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                });
              }
            });
          },

        },
        components: {
            // markdownEditor
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;*/
        height: 60px;
        border: 1px solid #939393;
        /*border-style: solid dotted dashed double;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
    }
    .header .header-tips{
      /*font-size: 10px;
      color: #939393;*/
      /*width: 80%;*/
      /*border: 1px solid black;*/
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 500px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      /*width: 150px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;*/

      /* border: 1px solid black; */
      /* width: 150px; */
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 8px 0;

    }

    .editor-content{
      /*border: 1px solid blue;*/
      margin: 0 auto;
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 80px 10px;
      background: white;
    }

    .input-new-tag{
      width: 120px;
    }

    .box-author{
      font-size: 10px;
      color: #939393;
      margin-bottom: 10px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #20a0ff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

</style>



// WEBPACK FOOTER //
// review.vue?4b339eb8